import type { FlaggedContentReport } from "@circle-react/types";

import { t } from "@/i18n-js/instance";
import type { StatusBadgeProps } from "@/react/components/SettingsApp/CompassCompat/StatusBadge";
import { StatusBadge } from "@/react/components/SettingsApp/CompassCompat/StatusBadge";

import { ReportContent } from "./ReportContent";
import { ReporterInfo } from "./ReporterInfo";

const i18nRoot = "settings.moderation.review_flagged_content_modal";

const getStatusBadgeConfig = (
  status?: string,
): { label: string; variant: StatusBadgeProps["variant"] } => {
  switch (status) {
    case "approved":
      return { label: t([i18nRoot, "status_approved"]), variant: "success" };
    case "rejected":
      return { label: t([i18nRoot, "status_rejected"]), variant: "danger" };
    default:
      return { label: t([i18nRoot, "status_pending"]), variant: "default" };
  }
};

export interface ReportItemProps {
  id?: number;
  profanity_filter_matches?: string;
  reported_at?: string;
  reported_reason_body?: string;
  reported_reason_type?: string;
  reporter?: FlaggedContentReport["reporter"];
  showStatusBadge?: boolean;
  status?: string;
}

export const ReportItem = ({
  id,
  profanity_filter_matches = "",
  reported_at = "",
  reported_reason_body,
  reported_reason_type = "",
  reporter,
  showStatusBadge,
  status,
}: ReportItemProps) => {
  const { label, variant } = getStatusBadgeConfig(status);

  return (
    <div key={id} className="flex flex-col gap-3">
      <div className="flex items-start justify-between">
        <ReporterInfo
          profanity_filter_matches={profanity_filter_matches}
          reported_at={reported_at}
          reported_reason_type={reported_reason_type}
          reporter={reporter}
        />
        {showStatusBadge && (
          <StatusBadge variant={variant}>{label}</StatusBadge>
        )}
      </div>
      <ReportContent
        profanity_filter_matches={profanity_filter_matches}
        reported_reason_body={reported_reason_body}
        reported_reason_type={reported_reason_type}
      />
    </div>
  );
};
